import { useEffect, useState } from "react";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../../Interfaces/base/IResponse";
import { IUbicacionDTO, IUbicacionEdit } from "../../../../../../Interfaces/auxiliar/IUbicacion";
import UbicacionService from "../../../../../../services/auxiliar/UbicacionService";
import { IPanelUbicacionEditar } from "./PanelUbicaciónEditar";

export const UsePaneUbicacionEditar=(props:IPanelUbicacionEditar)=>{
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const initial:IUbicacionEdit={
        codigo: "",
        nombre: "",
        ubicacionId: ""
    }
    const reset=()=>{
        setMensaje("")
        setRequest(initial)
        setStatus(0)
        props.onDismiss()
    }
    useEffect(()=>{
        if(props.isOpen){
          setRequest({...request,codigo:props.item.codigo,nombre:props.item.nombre,
            nivel:props.item.nivel,ubicacionId:props.item.ubicacionId})
          }
      },[props.isOpen])
     
     const putEditarUbicacion=()=>{
        setLoading(true)
        UbicacionService.UpdateUbicacion(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
           
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
     const [request,setRequest]=useState<IUbicacionEdit>(initial)
     return {request,setRequest,putEditarUbicacion,loading,reset,mensaje,status}

}